import { useCallback, useSyncExternalStore } from "react";

/** Whether a media query matches, following changes live. */
export function useMediaQuery(query: string): boolean {
  // Stable per query: a new subscribe each render would re-add the listener every time.
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia?.(query);
      list?.addEventListener("change", onChange);
      return () => list?.removeEventListener("change", onChange);
    },
    [query],
  );
  return useSyncExternalStore(subscribe, () => window.matchMedia?.(query).matches ?? false);
}
